export default __webpack_public_path__ + "static/media/high-conversion.4943ee05.svg";